// reducers/employeeSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showError, showSuccess } from "../../helpers/toast";

const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

const initialState = {
  password: null,
  new_password: null,
  passwordresetcode: null,
  loading: false,
  message: null,
  error: null,
  success: null,
};

export const resetPassword = createAsyncThunk(
  "resetPassword/",
  async (data) => {
    try {
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          "Content-Type": "application/json",
        },
      };
      const response = await API.post("/users/reset-password", data, config);
      return response.data;
    } catch (error) {
      throw new Error(
        error?.response?.data?.error || "Failed to Rest password"
      );
    }
  }
);

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        showSuccess("Password reset successfully, please login to continue");
        // alert("Password reset successfully, please login to continue");
        // window.location.href = "/";
        state.loading = false;
        state.message = action.payload.message;
        state.error = null;
        state.success = true;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        showError(action.error.message);
        // alert(action.error.message);
        state.loading = false;
        state.error = action.error;
      });
  },
});

export default resetPasswordSlice.reducer;
